// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Spin2_size_xxs{width:var(--spin-size-xxs);height:var(--spin-size-xxs);font-size:13px;line-height:12px}.Spin2_size_xxs.Spin2_position_center{margin-top:calc(var(--spin-size-xxs)/-2);margin-left:calc(var(--spin-size-xxs)/-2)}", ""]);
// Exports
module.exports = exports;
